/** Why an instance was passed over. Never fatal to the run. */
export enum PostDatingSkipReason {
	/** No instance came back for the id: out of programme scope, or deleted. */
	NOT_FOUND = 'NOT_FOUND',
	NOT_COMPLETED = 'NOT_COMPLETED',
	NOT_POST_DATED = 'NOT_POST_DATED',
	NOT_EID_EASY = 'NOT_EID_EASY',
	ALREADY_DATED = 'ALREADY_DATED',
	NO_PLACEMENTS = 'NO_PLACEMENTS',
	DIFFERENT_DATE = 'DIFFERENT_DATE',
	UNSIGNED_FILE = 'UNSIGNED_FILE',
	/**
	 * No outstanding date placement has a box on this instance (issued before its date anchor
	 * was added).
	 */
	NO_RESOLVED_POSITION = 'NO_RESOLVED_POSITION',
}
